import { useState } from 'react';
import api from '../api/axios';

export default function NetworkDebug() {
  const [results, setResults] = useState([]);
  const [running, setRunning] = useState(false);

  const run = async () => {
    setRunning(true);
    setResults([]);
    const tests = [
      { label: 'Health check', fn: () => api.get('/health') },
      { label: 'Admin login (wrong creds — expect 401)', fn: () => api.post('/auth/admin/login', { phone: '0000000000', password: 'wrong' }) },
      { label: 'Client login (wrong creds — expect 401)', fn: () => api.post('/auth/client/login', { phone: '0000000000', password: 'wrong' }) },
    ];
    for (const t of tests) {
      try {
        const res = await t.fn();
        setResults(r => [...r, { label: t.label, ok: true, msg: `✅ ${res.status} — ${JSON.stringify(res.data).slice(0, 80)}` }]);
      } catch (err) {
        const isExpected = err?.response?.status === 401;
        setResults(r => [...r, {
          label: t.label,
          ok: isExpected,
          msg: err?.response
            ? `${isExpected ? '✅' : '❌'} ${err.response.status} — ${err.response.data?.message}`
            : `🔴 Network error: ${err.message}`,
        }]);
      }
    }
    setRunning(false);
  };

  return (
    <div style={{ padding: 40, fontFamily: 'monospace', maxWidth: 700 }}>
      <h2>🔧 Network Debug</h2>
      <p style={{ color: '#64748b' }}>API base URL: <strong>{process.env.REACT_APP_API_URL || 'auto-detected'}</strong></p>
      <button onClick={run} disabled={running}
        style={{ padding: '10px 20px', background: '#3cb74e', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', marginBottom: 20 }}>
        {running ? 'Running tests...' : '▶ Run Network Tests'}
      </button>
      {results.map((r, i) => (
        <div key={i} style={{ padding: 12, marginBottom: 8, borderRadius: 8, background: r.ok ? '#f0fdf4' : '#fef2f2', border: `1px solid ${r.ok ? '#86efac' : '#fca5a5'}` }}>
          <p style={{ fontWeight: 700, margin: '0 0 4px' }}>{r.label}</p>
          <p style={{ margin: 0, fontSize: 13, color: r.ok ? '#166534' : '#991b1b' }}>{r.msg}</p>
        </div>
      ))}
    </div>
  );
}
